import { Page } from './../../../../../core/models/page';

export class AnnouncementTableRequest extends Page{
  announcementTitle?: string;
  createUser?: string;
  announcementStartDtStart?: Date;
  announcementStartDtEnd?: Date;
  announcementType?: string[];
  facility?: string;
  controlAdmin: boolean;

  constructor() {
    super();
    this.announcementStartDtEnd = undefined;
    this.announcementTitle = undefined;
    this.announcementStartDtStart = undefined;
    this.announcementType = undefined;
    this.createUser = undefined;
    this.facility = undefined;
    this.controlAdmin = false;
  }
}
